import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCaseFromCycleConfirmationModal = ({
  dropdownElInfo,
  deleteTestCaseOpen,
  setDeleteTestCaseOpen,
  setTestCasesToggler
}) => {
  const [loading, setLoading] = useState(false)
  const isBlueprint = Boolean(dropdownElInfo?.isBlueprint)

  const handleCloseDeleteDialog = () => {
    setDeleteTestCaseOpen(false)
  }

  const handleDeleteTestCase = async () => {
    setLoading(true)
    try {
      if (isBlueprint && dropdownElInfo?.id) {
        await PageService.deleteTestCases([dropdownElInfo.id])
      } else if (dropdownElInfo?.cycleItemId) {
        await PageService.removeCycleItem(dropdownElInfo.cycleItemId)
      } else if (dropdownElInfo?.cycleId && dropdownElInfo?.pageId) {
        await PageService.removeCyclePage(
          dropdownElInfo.cycleId,
          dropdownElInfo.pageId
        )
      } else {
        setLoading(false)
        return
      }
      setTestCasesToggler(prev => !prev)
      setDeleteTestCaseOpen(false)
      setLoading(false)
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteTestCaseOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Test Case
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            {isBlueprint
              ? 'Are you sure you want to delete this test case? This will permanently remove it from the system, and it cannot be restored.'
              : 'Are you sure you want to remove this test case from the project version? It will stay available in Blueprints.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteTestCase} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCaseFromCycleConfirmationModal
